import React, { useEffect } from 'react';
import isUndefined from 'lodash/isUndefined';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';

import { env } from '../../config';

const placeholder = '/assets/img/badges/placeholder.png';

const Badges = ({
  all = false,
}) => {
  const [res, req] = useHttpStatus();

  useEffect(() => {
    req({ url: '/api/quiz/badges' });
  }, []);

  const badgeImgType = () => {
    let src = '';

    if (['y3', 'y4', 'y5', 'y6', 'p2'].includes(env.user.lv)) src = 'p2';
    if (['y7', 'y8', 'y9', 'y89', 's1'].includes(env.user.lv)) src = 's1';
    if (['o', 's2'].includes(env.user.lv)) src = 's2';

    return `${src}CoverImg`;
  };

  return (
    <PageHttp res={res}>
      {(list) => {
        const badges = all ? list : list.filter((b) => b.gained);
        const imgSrc = badgeImgType();

        return (
          <>
            <div className="container-fluid text-center">
              <div className="row">
                {badges.map((b) => (
                  <div
                    key={b._id}
                    className="col-md-4 mt-4"
                  >
                    <div
                      className="m-auto"
                      style={{ width: '170px' }}
                    >
                      {(all && !isUndefined(b.viewed) && !b.viewed)
                        && (
                          <div
                            className="btn-primary px-2"
                            style={{
                              position: 'absolute',
                              borderRadius: '4px',
                            }}
                          >
                            New
                          </div>
                        )
                      }
                      <img
                        src={b.gained ? b[imgSrc] : placeholder}
                        style={{ width: '170px' }}
                      />
                    </div>
                      <p className="m-auto">{b.title}</p>
                  </div>
                ))}
              </div>
            </div>
          </>
        );
      }}
    </PageHttp>
  );
};

export default Badges;
